class BuyTogether {
  constructor() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    setTimeout(() => {
      this.container = document.querySelector('[data-buy-together]');
      if (!this.container) return;

      this.preselect = this.container.getAttribute('data-preselect') === 'true';
      this.buttonText = this.container.getAttribute('data-button-text') || 'Adicionar ao carrinho';
      this.emptyButtonText = this.container.getAttribute('data-empty-button-text') || 'Selecione os produtos';

      this.ensureLockedChecked();
      this.bindEvents();
      this.selectFirstAvailableVariant();
      if (this.preselect) {
        this.selectAllProductsByDefault();
      }
      this.updateCheckboxLabels();
      this.updateTotalPrice();
    }, 500);
  }

  updateCheckboxLabels() {
    if (!this.container) return;

    this.container.querySelectorAll('.buy-together-value').forEach((checkbox) => {
      const label = this.container.querySelector(`label[for="${checkbox.id}"]`);
      if (!label) return;

      const isChecked = checkbox.checked || checkbox.getAttribute('data-locked') === 'true';
      label.textContent = isChecked ? 'Produto adicionado' : 'Adicionar este produto';
    });
  }

  ensureLockedChecked() {
    if (!this.container) return;

    this.container.querySelectorAll('.buy-together-value[data-locked="true"]').forEach((checkbox) => {
      checkbox.checked = true;
    });
  }

  getSelectedCheckboxes() {
    if (!this.container) return [];

    return Array.from(this.container.querySelectorAll('.buy-together-value')).filter((checkbox) => {
      if (checkbox.getAttribute('data-locked') === 'true') {
        checkbox.checked = true;
        return true;
      }
      return checkbox.checked;
    });
  }

  bindEvents() {
    document.addEventListener('change', (e) => {
      if (!this.container) return;
      if (
        e.target.classList.contains('buy-together-value') ||
        e.target.classList.contains('variant-select__input')
      ) {
        if (!this.container.contains(e.target)) return;
        if (e.target.classList.contains('buy-together-value')) {
          this.updateCheckboxLabels();
        }
        this.updateTotalPrice();
      }
    });

    const buyButton = this.container.querySelector('.buy-together-button');
    if (buyButton) {
      buyButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }

  selectFirstAvailableVariant() {
    if (!this.container) return;

    this.container.querySelectorAll('.product-item-buy-together').forEach((productBlock) => {
      const variantInputs = productBlock.querySelectorAll('.variant-select__input');
      let firstAvailableFound = false;

      variantInputs.forEach((input) => {
        const label = productBlock.querySelector(`label[for="${input.id}"]`);

        if (!input.classList.contains('unavailable') &&
            !label.classList.contains('unavailable') &&
            !firstAvailableFound) {
          input.checked = true;
          firstAvailableFound = true;
        } else {
          input.checked = false;
        }
      });
    });
  }

  selectAllProductsByDefault() {
    if (!this.container) return;

    const checkboxes = this.container.querySelectorAll('.buy-together-value:not([data-locked="true"])');
    
    checkboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });
    
    checkboxes.forEach((checkbox) => {
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateButtonLabel(hasSelection) {
    if (!this.container) return;

    const buyButton = this.container.querySelector('.buy-together-button');
    if (!buyButton) return;

    const buttonTextElement = buyButton.querySelector('.button__text');
    if (!buttonTextElement) return;

    buttonTextElement.textContent = hasSelection ? this.buttonText : this.emptyButtonText;
  }

  updateTotalPrice() {
    if (!this.container) return;

    const totalTextElement = this.container.querySelector('.buy-together-text');
    const totalComparePriceElement = this.container.querySelector('.buy-together-compare-price');
    const totalPriceElement = this.container.querySelector('.buy-together-price');
    const installmentInfoElement = this.container.querySelector('.buy-together-installments');
    const buyButton = this.container.querySelector('.buy-together-button');

    if (!totalTextElement || !totalPriceElement || !installmentInfoElement || !buyButton) {
      return;
    }

    let total = 0;
    let totalCompare = 0;
    let maxInstallments = 1;
    let selectedProducts = [];

    const checkedCheckboxes = this.getSelectedCheckboxes();
    
    checkedCheckboxes.forEach((checkbox) => {
      const price = parseInt(checkbox.getAttribute('data-price'), 10);
      if (!price || price <= 0) return;

      total += price;
      maxInstallments = 4;

      const productId = checkbox.getAttribute('data-product-id');
      if (productId) {
        selectedProducts.push({
          id: productId,
          quantity: 1,
        });
      }

      const productBlock = checkbox.closest('.buy-together-product');
      const productItem = productBlock && productBlock.querySelector('.product-item');
      if (!productItem) return;

      const comparePriceElement = productItem.querySelector('.product-price--compare del span, .product-price--compare del, del span');
      if (comparePriceElement) {
        const compareText = comparePriceElement.textContent.trim();
        const comparePrice = this.extractPriceFromText(compareText);
        if (comparePrice > 0) {
          totalCompare += comparePrice;
        }
      }
    });

    totalTextElement.innerHTML = 'Leve os produtos selecionados por:';

    if (total > 0) {
      const installmentValue = total / maxInstallments;
      totalPriceElement.classList.remove('-text');

      installmentInfoElement.innerHTML = `<strong>${maxInstallments}x de ${this.formatCurrency(installmentValue)}</strong>`;

      if (totalCompare > total) {
        totalPriceElement.innerHTML = `ou ${this.formatCurrency(total)} à vista <span class="buy-together-compare-price">${this.formatCurrency(totalCompare)}</span>`;
      } else {
        totalPriceElement.innerHTML = `ou ${this.formatCurrency(total)} à vista`;
      }
      totalComparePriceElement.style.display = 'none';

      buyButton.style.display = 'block';
      buyButton.dataset.products = JSON.stringify(selectedProducts);
      this.updateButtonLabel(true);
    } else {
      totalComparePriceElement.style.display = 'none';
      installmentInfoElement.innerHTML = '';
      totalPriceElement.classList.add('-text');
      totalPriceElement.textContent = 'Nenhum produto selecionado';
      buyButton.style.display = 'block';
      buyButton.dataset.products = '[]';
      this.updateButtonLabel(false);
    }
  }

  extractPriceFromText(text) {
    const priceMatch = text.match(/R\$\s*([\d.,]+)/);
    if (priceMatch) {
      let priceStr = priceMatch[1];
      priceStr = priceStr.replace(/\./g, '').replace(',', '.');
      return Math.round(parseFloat(priceStr) * 100);
    }
    return 0;
  }

  formatCurrency(value) {
    const amount = value / 100;
    const formatted = new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
    
    const withComma = formatted.replace('.', ',');
    const result = `R$ ${withComma}`;
    return result;
  }

  async addToCart() {
    if (!this.container) return;

    const selectedProducts = [];
    this.getSelectedCheckboxes().forEach((checkbox) => {
      const productId = checkbox.getAttribute('data-product-id');
      if (productId) {
        selectedProducts.push({
          id: productId,
          quantity: 1
        });
      }
    });
    
    if (selectedProducts.length === 0) {
      return;
    }

    const buyButton = this.container.querySelector('.buy-together-button');

    try {
      if (buyButton) {
        buyButton.classList.add('working');
      }

      // Enviar diretamente como objeto, não como string JSON
      const response = await fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        body: JSON.stringify({ items: selectedProducts }),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        method: 'POST'
      });

      const responseData = await response.json();

      if (responseData.status === 422) {
        // Erro de estoque
        return;
      }

      // Atualizar o cart sidebar usando o mesmo método do product-form
      const cartResponse = await fetch('?section_id=helper-cart');
      const cartText = await cartResponse.text();

      const sectionInnerHTML = new DOMParser().parseFromString(cartText, 'text/html');
      const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;

      if (document.getElementById('AjaxCartForm')) {
        const cartItems = document.getElementById('AjaxCartForm');
        cartItems.innerHTML = cartFormInnerHTML;
        cartItems.ajaxifyCartItems();

        // Atualiza apenas os valores do footer que já está renderizado no Liquid
        const footerTotal = document.querySelector('#AjaxCartSubtotal .cart__total strong');
        if (footerTotal) {
          const totalPriceElement = cartItems.querySelector('[data-cart-total-price]');
          if (totalPriceElement) {
            footerTotal.textContent = totalPriceElement.getAttribute('data-cart-total-price');
          }
        }

        // Atualizar contadores do cart no header usando os dados do AjaxCartForm
        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          const cartCountElement = document.querySelector('#AjaxCartForm [data-cart-count]');
          if (cartCountElement) {
            elm.textContent = cartCountElement.textContent;
          }
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          const cartTotalElement = document.querySelector('#AjaxCartForm [data-cart-total]');
          if (cartTotalElement) {
            elm.textContent = cartTotalElement.textContent;
          }
        });
      }

      // Disparar evento de add-to-cart para compatibilidade
      document.dispatchEvent(new Event('add-to-cart'));

      // Abrir o cart sidebar
      if (document.querySelector('[data-js-site-cart-sidebar]')) {
        document.querySelector('[data-js-site-cart-sidebar]').show();
      }

      // Renderizar recomendações se existir
      if (document.getElementById('cart-recommendations')) {
        document.getElementById('cart-recommendations').generateRecommendations();
      }

      // a11y - anunciar para leitores de tela
      if (document.getElementById('screen-reader-info')) {
        document.getElementById('screen-reader-info').innerText = 'Produtos adicionados ao carrinho';
        setTimeout(() => {
          document.getElementById('screen-reader-info').innerText = '';
        }, 1000);
      }

    } catch (error) {
      // Erro silencioso
    } finally {
      // Remover o spinner do botão
      if (buyButton) {
        buyButton.classList.remove('working');
      }
    }
  }



}

document.addEventListener('DOMContentLoaded', function() {
  if (typeof BuyTogether !== 'undefined') {
    new BuyTogether();
  }
});

if (document.readyState === 'loading') {
} else {
  if (typeof BuyTogether !== 'undefined') {
    new BuyTogether();
  }
}
